import { Typography } from "components/miloDesignSystem/atoms/typography";
import { TypographyProps } from "components/miloDesignSystem/atoms/typography/types";
import { formatDistanceToNow, isToday, isYesterday } from "date-fns";
import { getStandardDateFormat, getStandardTimeFormat } from "utilities";

const formatCustomDateLabel = (date: Date) => {
  const now = new Date();
  const distance = formatDistanceToNow(date);

  if (distance.includes("minute") && !distance.includes("hour")) {
    const minutesAgo = Math.abs(Math.floor(date.getTime() - now.getTime()) / (1000 * 60));
    return `${minutesAgo} minut temu`;
  } else if (distance.includes("hour") && !distance.includes("day")) {
    const hoursAgo = Math.floor(Math.abs(date.getTime() - now.getTime()) / (1000 * 60 * 60));
    const minutesAgo = Math.floor(Math.abs(date.getTime() - now.getTime()) / (1000 * 60)) % 60;

    if (hoursAgo <= 6) {
      return `${hoursAgo}h ${minutesAgo}min temu`;
    } else if (isToday(date)) {
      return "dzisiaj";
    } else if (isYesterday(date)) {
      return `wczoraj, ${getStandardTimeFormat(date)}`;
    }
  } else if (isToday(date)) {
    return "dzisiaj";
  } else if (isYesterday(date)) {
    return `wczoraj, ${getStandardTimeFormat(date)}`;
  } else {
    return getStandardDateFormat(date);
  }
};

interface Props {
  createdAt: string;
  fontSize: TypographyProps["fontSize"];
  fontWeight: TypographyProps["fontWeight"];
}

export const CreatedAtLabel = ({ createdAt, fontSize, fontWeight }: Props) => {
  return (
    <Typography fontSize={fontSize} fontWeight={fontWeight}>
      {formatCustomDateLabel(new Date(createdAt))}
    </Typography>
  );
};
